/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Macos_2Inputs */

const en_pc_dl_macos_2 = /** @type {(inputs: Pc_Dl_Macos_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the .dmg and drag PdfCraft into your Applications folder.`)
};

const zh_pc_dl_macos_2 = /** @type {(inputs: Pc_Dl_Macos_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 .dmg，把 PdfCraft 拖进「应用程序」文件夹。`)
};

/**
* | output |
* | --- |
* | "Open the .dmg and drag PdfCraft into your Applications folder." |
*
* @param {Pc_Dl_Macos_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_macos_2 = /** @type {((inputs?: Pc_Dl_Macos_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Macos_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_macos_2(inputs)
	return zh_pc_dl_macos_2(inputs)
});
export { pc_dl_macos_2 as "pc.dl.macos.2" }